import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormWrapper from '../../../../../library/form/components/FormWrapper';

const ProdIOOOfrViewRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemId" }} />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                    action={{ paramName: "variation2Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyReturned" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "resUnitCost" }}/>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "processUnitCost" }}/>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "ohUnitCost" }}/>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "totalUnitCost" }}/>
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "actionInvType" }} />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actionInvId", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
            </ul>
        )
}

export default ProdIOOOfrViewRow